export const SET_HOTELS_NEW = 'SET_HOTELS_NEW';
export const SET_PARAMS_SEARCH = 'SET_PARAMS_SEARCH';
export const RESET_HOTELS_NEW = 'RESET_HOTELS_NEW';
export const NO_RESULTS = 'NO_RESULTS';
export const RESULTS = 'RESULTS';
export const SET_OBSERVATIONS = 'SET_OBSERVATIONS';
export const RESET_OBSERVATIONS = 'RESET_OBSERVATIONS';
export const SET_QUERY = 'SET_QUERY';
export const CLEAN_QUERY = 'CLEAN_QUERY';
export const SET_FILTERS = 'SET_FILTERS';
export const CLEAN_FILTERS = 'CLEAN_FILTERS';

export const setHotelsNew = (hash) => ({
    type: SET_HOTELS_NEW,
    payload: hash 
});

export const setParamsSearch = (params) => ({
    type: SET_PARAMS_SEARCH,
    payload: params
});

export const resetHotelsNew = () => ({
    type: RESET_HOTELS_NEW
});

export const noResults = (message) => ({
    type: NO_RESULTS,
    payload: message
});

export const results = () => ({
    type: RESULTS
});

export const setObservations = (observations) => ({
    type: SET_OBSERVATIONS,
    payload: observations
});

export const resetObservations = () => ({
    type: RESET_OBSERVATIONS
});

export const setQuery = () => ({
    type: SET_QUERY
});

export const cleanQuery = () => ({
    type: CLEAN_QUERY
});

export const setFilters = (histogram) => ({
    type: SET_FILTERS,
    payload: histogram
})

export const cleanFilters = () => ({
    type: CLEAN_FILTERS
});


// WEBPACK FOOTER //
// ./src/actions/hotelsActions.js